/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { ArrowUiAuthLogoutIcon16Light } from './ArrowUiAuthLogoutIcon16Light';
import { ArrowUiAuthLogoutIcon16Regular } from './ArrowUiAuthLogoutIcon16Regular';
import { ArrowUiAuthLogoutIcon16Solid } from './ArrowUiAuthLogoutIcon16Solid';
import { ArrowUiAuthLogoutIcon20Light } from './ArrowUiAuthLogoutIcon20Light';
import { ArrowUiAuthLogoutIcon20Regular } from './ArrowUiAuthLogoutIcon20Regular';
import { ArrowUiAuthLogoutIcon20Solid } from './ArrowUiAuthLogoutIcon20Solid';
import { ArrowUiAuthLogoutIcon24Regular } from './ArrowUiAuthLogoutIcon24Regular';
import { ArrowUiAuthLogoutIcon24Solid } from './ArrowUiAuthLogoutIcon24Solid';
import { ArrowUiAuthLogoutIcon32Regular } from './ArrowUiAuthLogoutIcon32Regular';
import { ArrowUiAuthLogoutIcon64Regular } from './ArrowUiAuthLogoutIcon64Regular';
var sizes = {
    16: {
        light: ArrowUiAuthLogoutIcon16Light,
        regular: ArrowUiAuthLogoutIcon16Regular,
        solid: ArrowUiAuthLogoutIcon16Solid,
    },
    20: {
        light: ArrowUiAuthLogoutIcon20Light,
        regular: ArrowUiAuthLogoutIcon20Regular,
        solid: ArrowUiAuthLogoutIcon20Solid,
    },
    24: {
        regular: ArrowUiAuthLogoutIcon24Regular,
        solid: ArrowUiAuthLogoutIcon24Solid,
    },
    32: {
        regular: ArrowUiAuthLogoutIcon32Regular,
    },
    64: {
        regular: ArrowUiAuthLogoutIcon64Regular,
    },
};
export var ArrowUiAuthLogoutIcon = forwardRef('ArrowUiAuthLogoutIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
